import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

// Components
import Toast from "components/WMS/Toast";

// Assets
import ValidatedIcon from "assets/img/validated.svg";

ShippedToast.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

function ShippedToast({isOpen, handleClose, ...props}) {
    const icon = (
        <img
            src={ValidatedIcon}
            alt={props.intl.formatMessage({id: 'wms.shipping.toast.shipped'})}
            style={{width: '20px', height: '20px'}}
        />
    );

    return (
        <Toast
            bottomHeight={'96px'}
            icon={icon}
            title={<FormattedMessage id={'wms.shipping.toast.shipped'} />}
            open={isOpen}
            handleClose={handleClose}
        />
    );
}

export default injectIntl(ShippedToast);
